import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurnip = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M21.77,17c-1.45,3-5,5.24-9.12,5.44l-.65,0-.65,0c-4.16-.2-7.67-2.4-9.12-5.44,3.21-1.37,5.06,1.39,9.27,1.66h1C16.71,18.43,18.56,15.67,21.77,17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M22.5,13.91A7.09,7.09,0,0,1,21.77,17c-1.45,3-5,5.24-9.12,5.44l-.65,0-.65,0c-4.16-.2-7.67-2.4-9.12-5.44a7.09,7.09,0,0,1-.73-3.13C1.5,5.32,12,1.5,12,1.5S22.5,5.32,22.5,13.91Z"
		})
	]
});
const ForwardRef = forwardRef(SvgTurnip);
export default ForwardRef;
